import { Card, DataTable, EmptyState, Link, Page } from '@shopify/polaris';
import Pagination from 'components/pagination';
import SimpleFilter from 'components/simpleFilter';
import dateandtime from 'date-and-time';
import helpers from 'helpers/index';
import { TypedShopping_cart, useGetShoppingCarts } from 'queries/shopping_cart.query';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import emptyIMG from '../../media/images/empty.png';

export default function ShoppingCartList() {
  let history = useNavigate();

  /**
   * If user apply filter, it will add to URL, then parse URL back to initial state
   */

  let { search } = useLocation();
  let StringQuery = helpers.ExtractUrl(search);

  const initialQuery = {
    query: '',
    page: 1,
    limit: 20,
    sort: 'createdAt:desc',
  };
  const [mainQuery, setMainQuery] = useState({ ...initialQuery, ...StringQuery });
  const { data: all_entities, isLoading, refetch: getEntities } = useGetShoppingCarts(mainQuery);

  /**
   * Change page number
   */
  const onChangePagination = useCallback((numPage: number, limit: number) => {
    setMainQuery((prevMainQuery) => ({ ...prevMainQuery, page: numPage, limit: limit }));
  }, []);

  /**
   * I do not know ...
   * Bug: In React, do NOT remove this code
   */
  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  const reduceRequest = useCallback((mainQuery) => {
    getEntities();
    return mainQuery;
  }, []);

  const reduceRequestMemo = useMemo(() => {
    return helpers.debounce((_value) => {
      reduceRequest?.call(this, _value);
    }, 500);
  }, []);


  useEffect(() => {
    let buildURLSearch = helpers.buildEndUrl(mainQuery);
    if (window.location.search !== buildURLSearch) history('/shopping_cart' + buildURLSearch);
    reduceRequestMemo(mainQuery);
  }, [mainQuery]);

  const [totalItems, setTotalItems] = useState(0);
  const [entities, setEntities] = useState<TypedShopping_cart[] | null>(null);

  useEffect(() => {
    if (all_entities) {
      let { body, totalItems } = all_entities;
      setTotalItems(totalItems);
      setEntities(body);
    }
  }, [all_entities]);

  const EmptyData = () => (
    <EmptyState heading="Không có giỏ hàng nào!" image={emptyIMG}>
      <p>Oh, Không có gì ở đây. Hãy thử bỏ bộ lọc hoặc tạo mới.</p>
    </EmptyState>
  );

  return (
    <>
      <Helmet>
        <title>Giỏ hàng</title>
      </Helmet>
      <Page title="Quản lý giỏ hàng" subtitle="Quản lý tất cả giỏ hàng của người dùng">
        <Card padding={'0'}>
          <SimpleFilter
            loading={isLoading}
            onCallback={filterCallback}
            options={[]}
            sortField={[
              { label: 'Ngày cập nhật', field: 'lastUpdated' },
              { label: 'Giá trị', field: 'total_value' },
              { label: 'Số món', field: 'total_quantity' },
            ]}
          />
          {helpers.isEmpty(entities) ? (
            <EmptyData />
          ) : (
            <DataTable
              verticalAlign="middle"
              columnContentTypes={['text', 'numeric', 'numeric', 'numeric', 'numeric']}
              headings={['Tài khoản', 'Tổng giá', 'Tổng số món', 'Tạo vào', 'Cập nhật gần nhất']}
              rows={
                entities?.map((el, index) => {
                  return [
                    <Link url={`/shopping_cart/${el.user_id}/${el?.id}`}>{el.user.display_name}</Link>,
                    helpers.formatNumber(el.total_value),
                    helpers.formatNumber(el.total_quantity),
                    dateandtime.format(new Date(Number(el.createdAt)), 'DD-MM-YYYY'),
                    el.lastUpdated?dateandtime.format(new Date(Number(el.lastUpdated)), 'DD-MM-YYYY'):"",
                  ];
                }) || []
              }
            />
          )}
        </Card>
      </Page>
      <br />
      {totalItems > mainQuery.limit ? (
        <Pagination TotalRecord={totalItems} activeCurrentPage={mainQuery.page} pageSize={mainQuery.limit} onChange={onChangePagination} />
      ) : null}
    </>
  );
}

